export const POPOVER_WIDTH = 300
export const NON_DRAGGABLE_OFFSET = 10
export const POPOVER_DISTANCE_FROM_BUTTON = 25
export const POSITION_STATE_KEY = 'mp-recorder-button-position'
